/** Concise copy for Creator Intelligence — trend, improving filter, etc. */

export const PERF_HUB_TREND_HELP = {
  summary:
    'Compares engagement on the latest refresh vs the one before (↑ · → · ↓).',
  improving: 'Engagement up 12%+ since your last refresh—the post is still climbing.',
  flat: 'Engagement changed less than 12% since the last refresh.',
  declining: 'Engagement down 12%+ since the last refresh.',
  unknown: 'Refresh metrics twice to see a trend.',
};

export const PERF_HUB_IMPROVING_FILTER_HELP =
  'Shows creators whose engagement rose since the previous refresh—momentum is building.';

export function trendTooltip(trend) {
  switch (trend) {
    case 'improving':
      return PERF_HUB_TREND_HELP.improving;
    case 'declining':
      return PERF_HUB_TREND_HELP.declining;
    case 'flat':
      return PERF_HUB_TREND_HELP.flat;
    default:
      return PERF_HUB_TREND_HELP.unknown;
  }
}
